export class IcdCodeSerializer {
  static deserialize = icdCode => ({
    id: icdCode.limsICDCode,
    icdCode: icdCode.icdCode,
    description: icdCode.description,
    title: `${icdCode.icdCode} ${icdCode.description}`,
  });
}
